const FIELD_LABELS = {
  fecha: 'Fecha',
  id_almacen: 'Almacen',
  codigo_variedad: 'Variedad',
  kilos: 'Kilos de entrada',
  grupos_4_palots: 'Grupos de 4 palots',
  cruces_palots: 'Grupos de 4 palots',
  id_peso_palot: 'Peso del palot',
  kilos_palot: 'Peso del palot',
  id_peso_caja: 'Peso de la caja',
  peso_caja: 'Peso de la caja',
  observaciones: 'Observaciones',
  otros_calibres: 'Otros calibres',
  p_otros_calibres: 'Palots de otros calibres',
  retorno: 'Retorno',
  p_retorno: 'Palots de retorno',
  verde: 'Verde',
  p_verde: 'Palots de verde',
  segunda: 'Segunda',
  p_segunda: 'Palots de segunda',
  bajo_calibre: 'Bajo calibre',
  p_bajo_calibre: 'Palots de bajo calibre',
  industria: 'Industria',
  p_industria: 'Palots de industria',
  podrido: 'Podrido',
  porcentaje: 'Porcentaje',
  palets_entrada: 'Palets de la entrada',
  clasificacion: 'Clasificacion',
  precalibrado: 'Precalibrado',
};

const readableSegment = (segment) => FIELD_LABELS[segment] || segment
  .replace(/([a-z])([A-Z])/g, '$1 $2')
  .replace(/_/g, ' ')
  .replace(/^./, (letter) => letter.toUpperCase());

export const getEntradaHistoryLabel = (field) => {
  if (typeof field !== 'string' || !field.trim()) return 'Campo';

  const path = field.trim();
  if (FIELD_LABELS[path]) return FIELD_LABELS[path];

  const classification = /^clasificacion\.([^.]+)\.(kilos|palots)$/.exec(path);
  if (classification) {
    return `${readableSegment(classification[1])} (${classification[2] === 'kilos' ? 'kg' : 'palots'})`;
  }

  return path.replace(/\[(\d+)\]/g, '.$1').split('.').map(readableSegment).join(' / ');
};
